import * as http from "./base";
import axios from "axios";
import md5 from "blueimp-md5";

const prefix = "/users";

export async function fetchUser() {
  return await http.get(`${prefix}-retrieve`);
}

export async function updateUser(data, extra) {
  return await http.patch(`${prefix}-update`, data, extra);
}

/**
 * Returns Gravatar image for a particular email
 * @param email
 * @param useDefaultImage
 */
export async function fetchGravatar(email, useDefaultImage = true) {
  return await axios.get(`https://gravatar.com/avatar/${md5(email)}?&d=404`);
}

export async function updateAccountImage(image) {
  return await http.upload("/user-image-upload", { image });
}
